"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _queryString = _interopRequireDefault(require("query-string"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let helperObject = {};
const useHelperApp = helpers => {
  const history = (0, _reactRouterDom.useHistory)();
  const location = (0, _reactRouterDom.useLocation)();
  const query = _queryString.default.parse(location.search);
  const [currentHelper, setCurrentHelper] = (0, _react.useState)(query?.helper);
  const handleToggleHelper = (0, _react.useCallback)(helper => {
    setCurrentHelper(helper !== currentHelper ? helper : undefined);
  }, [currentHelper]);
  const isOpen = hlp => {
    return currentHelper === hlp;
  };
  (0, _react.useEffect)(() => {
    // Keep object outside of hook to avoid redraw, oncly change when keys change
    if (!(0, _isEqual.default)(Object.keys(helperObject), Object.keys(helpers))) {
      helperObject = helpers;
    }
    if (currentHelper !== query?.helper) {
      const newQuery = {
        ...query,
        helper: currentHelper
      };
      history.push({
        pathname: location.pathname,
        search: `?${_queryString.default.stringify(newQuery)}`
      });
    }
  }, [currentHelper, helpers, history, location, query]);

  // Set the HelperComponent
  const HelperComponent = (0, _react.useMemo)(() => props => {
    if (!query?.helper) return null;
    let Component = null;
    Component = helperObject[query?.helper];
    if (!Component) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
      onToggle: () => handleToggleHelper(query?.helper),
      ...props
    });
  }, [handleToggleHelper, query.helper]);

  // Set up the helperToggleFunctions
  const helperToggleFunctions = {};
  Object.keys(helperObject).forEach(h => {
    helperToggleFunctions[h] = () => handleToggleHelper(h);
  });
  return {
    currentHelper,
    HelperComponent,
    helperToggleFunctions,
    isOpen
  };
};
var _default = exports.default = useHelperApp;